import React from 'react'
import { CORE_TOOLS, OPS_DASHBOARDS } from './mockData'
import { ICON_MAP } from './icons'

function ModuleCard({ module, onClick }) {
  const IconComponent = ICON_MAP[module.icon]
  const Tag = onClick ? 'div' : 'a'
  const props = onClick
    ? { className: 'module-card', onClick, style: { cursor: 'pointer' } }
    : { className: 'module-card', href: module.href }
  return (
    <Tag {...props}>
      <div className="card-stripe" style={{ background: module.stripeColor }} />
      <div className="card-head">
        <div className="card-icon" style={{ background: module.iconBg, color: module.iconColor }}>
          {IconComponent && <IconComponent size={16} />}
        </div>
        <div className="card-title">{module.title}</div>
        {module.pill && (
          <span className={`pill pill-${module.pill.tone}`} style={{ fontSize: 9, marginLeft: 'auto' }}>
            <span className="dot" />{module.pill.label}
          </span>
        )}
      </div>
      <div className="card-desc">{module.desc}</div>
      <div className="card-stats">
        {module.stats.map((s, i) => (
          <span className="card-stat" key={i}><b>{s.value}</b> {s.label}</span>
        ))}
      </div>
    </Tag>
  )
}

export default function ModuleCards({ commStats, onOpenComm }) {
  return (
    <>
      <div>
        <div className="section-head">
          <h3>Core Tools</h3>
          <span className="pill pill-neutral" style={{ fontSize: '9.5px' }}>{CORE_TOOLS.length} modules</span>
        </div>
        <div className="cards-grid">
          {CORE_TOOLS.map((m) => {
            if (m.id === 'communications' && commStats) {
              const total = (commStats.voicemails || 0) + (commStats.unreadSms || 0) + (commStats.missedCalls || 0)
              const patched = {
                ...m,
                pill: total > 0 ? { label: `${total} new`, tone: 'risk' } : null,
                stats: [
                  { value: String(commStats.voicemails || 0), label: 'VM' },
                  { value: String(commStats.unreadSms || 0), label: 'SMS' },
                  { value: String(commStats.missedCalls || 0), label: 'missed' }
                ]
              }
              return <ModuleCard key={m.id} module={patched} onClick={onOpenComm} />
            }
            return <ModuleCard key={m.id} module={m} />
          })}
        </div>
      </div>

      <div>
        <div className="section-head">
          <h3>Operations Dashboards</h3>
          <span className="pill pill-neutral" style={{ fontSize: '9.5px' }}>{OPS_DASHBOARDS.length} dashboards</span>
        </div>
        <div className="cards-grid">
          {OPS_DASHBOARDS.map((m) => <ModuleCard key={m.id} module={m} />)}
        </div>
      </div>
    </>
  )
}
